<template>
  <v-container>
    <a-authorization-card
      class="ma-5"
      color="secondary"
      icon="mdi-arrow-decision"
      title="Accrochez-vous !"
      text="Vous allez être redirigé vers le serveur d'authentification."
      sub="Cela peut prendre quelques instants."
    />
  </v-container>
</template>

<script>
import { oauth2Service } from "@/services";
import makeFields from "@/mixins/makeFields";

export default {
  props: {
    to: {
      type: Object,
      default: null,
    },
  },

  mounted() {
    if (this.to) {
      this.redirectTo = {
        name: this.to.name,
        path: this.to.path,
        params: this.to.params,
        query: this.to.query,
      };
    } else {
      this.redirectTo = { path: "/accueil" };
    }

    oauth2Service.loginCode();
  },

  computed: {
    ...makeFields({ redirectTo: "login/redirectTo" }),
  },
};
</script>
